import { render, staticRenderFns } from "./TemplateDocumentation.vue?vue&type=template&id=a7fca4c8&scoped=true&"
import script from "./TemplateDocumentation.vue?vue&type=script&lang=ts&"
export * from "./TemplateDocumentation.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateDocumentation.vue?vue&type=style&index=0&id=a7fca4c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fca4c8",
  null
  
)

export default component.exports